module.exports = __webpack_public_path__ + "img/stas-main.bf736a77.jpg";